namespace $ {

	$mol_style_define( $shm_hitalama_teams, {
		Team_menu_page: { flex: { basis: '14rem' }, minWidth: 'max-content' },
		Members_section: { flex: { direction: 'column' } },
		Member_add_row: { padding: $mol_gap.block, gap: $mol_gap.block, flex: { wrap: 'wrap' } },
		Member_id: { minWidth: '18rem', flex: { grow: 1 } },
		Member_add_status: { padding: { left: $mol_gap.block, right: $mol_gap.block } },
		Members: { display: 'block', maxWidth: '39rem', overflow: { x: 'auto' } },
		Members_head: { display: 'grid', gridTemplateColumns: '12rem 18rem 9rem', width: '39rem', border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } } },
		Member_row: { display: 'grid', gridTemplateColumns: '12rem 18rem 9rem', width: '39rem', border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } } },
		Member_name_head: { padding: $mol_gap.block },
		Member_id_head: { padding: $mol_gap.block },
		Member_admin_head: { padding: $mol_gap.block },
		Member_user_id: { padding: $mol_gap.block, overflow: 'hidden', textOverflow: 'ellipsis' },
		Member_admin: { justify: { content: 'center' } },
		Member_detail: { flex: { direction: 'column', grow: 1 } },
		Member_meta: { flex: { direction: 'column' }, padding: $mol_gap.block },
		Permissions_title: { padding: $mol_gap.block, font: { weight: 'bold' } },
		Permissions: { display: 'block', overflow: { x: 'auto', y: 'auto' } },
		Permission_head: { display: 'grid', gridTemplateColumns: 'minmax(12rem, 1fr) repeat(3, minmax(7rem, auto))', minWidth: '42rem', border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } } },
		Permission_row: { display: 'grid', gridTemplateColumns: 'minmax(12rem, 1fr) repeat(3, minmax(7rem, auto))', minWidth: '42rem', border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } } },
		Project_head: { padding: $mol_gap.block },
		Visible_head: { padding: $mol_gap.block },
		Prerelease_head: { padding: $mol_gap.block },
		Release_head: { padding: $mol_gap.block },
		Project_title: { padding: $mol_gap.block },
		Project_visible: { justify: { content: 'center' } },
		Project_prerelease: { justify: { content: 'center' } },
		Project_release: { justify: { content: 'center' } },
	} )

}
